import { z } from "zod";
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
/**
 * Solicitação de férias do colaborador (FASE-06-T48/T36) — abre uma instância
 * do workflow VACATION endereçada ao gestor direto.
 */
export const requestMeVacationSchema = z
    .object({
    startDate: z.string().regex(DATE_RE, "Use o formato AAAA-MM-DD"),
    endDate: z.string().regex(DATE_RE, "Use o formato AAAA-MM-DD"),
    reason: z.string().trim().max(500).optional(),
})
    .refine((d) => d.startDate <= d.endDate, {
    message: "startDate deve ser anterior ou igual a endDate",
    path: ["endDate"],
});
//# sourceMappingURL=request-me-vacation.js.map